import React from "react";
import "./style.scss";
import AssetIcon from "../asset-icon";
import ChevronOpen from "../../../../assets/AccOptionIcon.svg";
import { useTranslation } from "react-i18next";
import { useAssetVolatility } from "hooks/useAssetVolatility";
import useExchangeTimeFrame from "hooks/useExchangeTimeFrame";
import { AssetType } from "static/types";
import usePrice from "hooks/usePrice";

type PropType = {
  asset: any;
  onClick: any;
};

export const FavoriteCard: React.FC<PropType> = ({ onClick, asset }) => {
  const exchange = useExchangeTimeFrame(asset?.exchange);

  const { ask, last, mid, ask_yield, change, changePercent } = usePrice({
    exchange: exchange?.exchange_code,
    exchangeStatus: exchange?.status,
    symbol: asset.symbol,
    assetType: asset.type,
    ask: asset.ask,
    bid: asset.bid,
    ask_yield: asset.data?.ask_yield || null,
    bid_yield: asset.data?.bid_yield || null,
    price: asset.price,
    change: asset.change,
  });

  const { changedPart, unchangedPart, volatilityElementRef } =
    useAssetVolatility(last || mid);

  return (
    <div className="favorite-card" onClick={onClick}>
      <div className="fav-card-header">
        <AssetIcon asset={asset} />
        <p>{asset.symbol}</p>
      </div>

      <div className="fav-card-main">
        {asset.type == AssetType.Currency ? (
          <div className="price-gains-currency">
            <p>
              {+asset.bid.toFixed(4)} / {+asset.ask.toFixed(4)}{" "}
              {asset.currency.symbol}
            </p>
          </div>
        ) : [AssetType.Bond, AssetType.EuroBond].includes(asset.type) ? (
          // Те же значения и округление, что в списке рынка (market-asset):
          // доходность по ask и цена ask в % от номинала.
          <p>
            {ask_yield ? `${+ask_yield.toFixed(2)}% | ` : ""}
            {+(ask || last || mid).toFixed(2)}%
          </p>
        ) : (
          <p>
            <span style={{ color: "#2b2f38" }}>{unchangedPart}</span>
            <span id="volatility" ref={volatilityElementRef}>
              {changedPart}
            </span>
            {asset.percentPerAnnum ? "%" : asset.currency.symbol}
          </p>
        )}
        {change && (
          <span className={`percentage ${change < 0 ? "loss" : ""}`}>
            {changePercent}%
          </span>
        )}
      </div>
    </div>
  );
};

export const FavoritesViewAllCard = ({ onClick }: any) => {
  const { t } = useTranslation("app");

  return (
    <div className="favorite-card favorites-view-all-card" onClick={onClick}>
      <img src={ChevronOpen} alt="Open" />
      <p>{t("viewAll")}</p>
    </div>
  );
};
